import { axiosAjax } from './common'

export default {
	// get login logs
	getLogin(params) {
		return axiosAjax('/event/get_login_log', 'get', params)
	},
	// get team members logs
	getTeam(params) {
		return axiosAjax('/event/get_account_log', 'get', params)
	},
	// get cluster logs
	getCluster(params) {
		return axiosAjax('/event/get_net_log', 'get', params)
	},
	// get resource logs
	getResource(params) {
		return axiosAjax('/event/get_project_log', 'get', params)
	},
	// get alarm log
	getAlarmLog(params) {
		return axiosAjax('/event/get_notice_log', 'get', params)
	},
	// 新建/编辑/删除 事件通知
	handleEventNotice(params) {
		return axiosAjax('/event/alarm', 'post', params)
	},
	// 获取操作日志列表
	getActionList(params) {
		return axiosAjax('/search_tunnel', 'get', params)
	},
	// 获取所有成员
	getAllMenber(params) {
		return axiosAjax('/v1/account/list', 'get', { params: params })
	},
	// 获取所有资源名称
	getAllResourceName(params) {
		return axiosAjax('/resource/all_name', 'get', { params: params })
	},
	// 解冻日志文件
	unFreezeLog(params) {
		return axiosAjax('/unfreeze_tunnel_log', 'get', params)
	},

	// 获取最新未读告警通知数量
	getAlarmNotifyUnreadCounts(params) {
		return axiosAjax('/notice', 'get', { params: params })
	},

	// 关闭告警通知消息
	closeAlarmNotify() {
		return axiosAjax('/remove_notice', 'post')
	},

	// 查看日志
	viewLog(params) {
		return axiosAjax(`/download_tunnel_log`, 'get', params)
	},
}



// WEBPACK FOOTER //
// ./src/api/logs.js